import Api from "../services/Api";
import { utils } from "../../src/services/Utils";
import { get } from 'svelte/store';
import { weatherStore } from "../store";
const { weatherData, selectedCity, selectedTime, storedDate, loader, sliderData } = weatherStore;
export const getWeatherData = async () => {
    const random = Math.floor(Math.random() * 999999 + 10000);
    const response = await Api.get(`/weather/getArso?client_id=8c5205a95060a482f0fc96b9162d9e3f&location=all&_=${random}`, {});
    if (response.response) {
        response.response.sort(function (a, b) {
            if (a.city < b.city) {
                return -1;
            }
            if (a.city > b.city) {
                return 1;
            }
            return 0;
        });
        let city;
        response.response.map(function (element, index) {
            switch (element.city) {
                case "Nova Gorica":
                    element.position = "top: 66%; left: 33%;";
                    break;
                case "Koper":
                    element.position = "top: 83%; left: 35%;";
                    break;
                case "Kranj":
                    element.position = "top: 50%;left: 46%;";
                    break;
                case "Jesenice":
                    element.position = "top: 42%; left: 41%;";
                    break;
                case "Ljubljana":
                    element.position = "top: 61%;left: 51%;";
                    break;
                case "Postojna":
                    element.position = "top: 73%; left: 44%;";
                    break;
                case "Trbovlje":
                    element.position = "top: 59%;left: 60%;";
                    break;
                case "Novo mesto":
                    element.position = "top: 75%;left: 62%;";
                    break;
                case "Krško":
                    element.position = "top: 60%;left: 68%;";
                    break;
                case "Celje":
                    element.position = "top: 50%;left: 57%;";
                    break;
                case "Maribor":
                    element.position = "top: 35%;left: 72%;";
                    break;
                case "Murska Sobota":
                    element.position = "top: 32%;left: 81%;";
                    break;
                case "Slovenj Gradec":
                    element.position = "top: 39%;left: 60%;";
                    break;
                case "Bovec":
                    element.position = "top: 47%;left: 34%;";
                    break;
                case "Videm":
                    element.position = "top: 54%;left: 26%;";
                    break;
                case "Celovec":
                    element.position = "top: 30%;left: 42%;";
                    break;
                case "Gradec":
                    element.position = "top: 21%;left: 68%;";
                    break;
                case "Zagreb":
                    element.position = "top: 65%;left: 76%;";
                    break;
                case "Reka":
                    element.position = "top: 90%;left: 48%;";
                    break;
                case "Jageršek":
                    element.position = "top: 23%;left: 88%;";
                    break;
                default:
                    break;
            }
            selectedCity.set(response.response[9]); //izbira mesta
            let locationFromStorage;
            if (!localStorage.getItem("weatherLocation")) {
                localStorage.setItem("weatherLocation", response.response[9].city);
                city = response.response[9];
                locationFromStorage = response.response[9].city;
            }
            else {
                locationFromStorage = localStorage.getItem("weatherLocation");
                response.response.forEach(function (element) {
                    if (element.city === locationFromStorage) {
                        selectedCity.set(element);
                        city = element;
                    }
                });
            }
            element.data.forecast24h.map(function (forecastElement, forecastIndex) {
                if (forecastIndex === 0) {
                    forecastElement.selected = true;
                }
                else {
                    forecastElement.selected = false;
                }
            });
            element.data.forecast1h.map(function (forecastElement, forecastIndex) {
                forecastElement.timeline.map(function (timelineElement, timlineIndex) {
                    timelineElement.active = false;
                    /*if (timlineIndex === 0 && forecastIndex === 0 && city === element.city) {
                      timelineElement.active = true
                    }*/
                });
            });
            element.data.forecast3h.map(function (forecastElement, forecastIndex) {
                forecastElement.timeline.map(function (timelineElement, timlineIndex) {
                    timelineElement.active = false;
                });
            });
            element.data.observation[0].timeline.map(function (timelineElement, timlineIndex) {
                timelineElement.active = true;
            });
        });
        selectedCity.set(city);
        weatherData.set(response.response);
        let sliderHours = utils.setSliderHours(city);
        sliderData.set(sliderHours);
        //izbira dneva na izbrani lokaciji Trenutno definirano za Ljubljano
        const $weatherData = get(weatherData);
        if ($weatherData) {
            loader.set(false);
        }
    }
};
